module.exports = __webpack_public_path__ + "img/19.30274c04.jpg";